import React, { useContext } from 'react';
import { SB3RuleContext } from '../Rules/SB3RuleContext';

const symbols = ['+', '-', '×', '÷', '√', '(', ')', 'text']

const MathButton = ({ symbol, handleMath }: { symbol: string; handleMath: (obj: any) => {} }) => (
    <button data-testid="rulecomponents-mathpanelcomponent-button-1" className="tw-w-11 tw-h-11 tw-border hover:tw-bg-gray-200 tw-bg-white 
    tw-border-gray-150 tw-flex tw-items-center tw-justify-center tw-rounded-sm tw-text-xl"
        onClick={(e) => {
            handleMath({
                operator: symbols.includes(symbol) ? symbol : "numerical",
                name: symbol,
                type: symbol === 'text' ? "numerical" : "operator"
            })
        }}
    >
        {symbol}
    </button >
);

const MathPanel = () => {
    const { handleMathExp } = useContext(SB3RuleContext);

    return (
        <div className="tw-grid tw-grid-cols-5 tw-gap-1 tw-m-2">
            {symbols.map((symbol, index) => (
                <MathButton key={index} symbol={symbol} handleMath={handleMathExp} />
            ))}
        </div>
    );
};

export default MathPanel;
